<template>
    <div class="test-container">
        <div class="left-container">
            <div class="div-title">
                <div class="iconfont icon-dayinji"></div>
                <div class="div-label">打印测试表单</div>
            </div>
            <div class="form-container">
                <div class="top-tips">
                    <div class="top-tips-label">说明：</div>
                    <div>打印前请务必保证打印机正常在线，如不能成功打印，可微信咨询技术客服。</div>
                </div>
                <div class="form-main">
                    <el-form ref="printTestForm" :model="form" :rules="rule" label-width="100px">
                        <el-form-item label="设备编号：" prop="imei" required>
                            <el-input v-model="form.imei" placeholder="请输入打印设备编号(SN)"></el-input>
                        </el-form-item>
                        <el-form-item label="订单编号：">
                            <el-input :maxlength="64" v-model="form.orderNo" placeholder="选填，可输入订单编号，长度不能超过64">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="延迟打印：">
                            <el-input-number v-model="form.delay" controls-position="right" :min="0" label="描述文字">
                            </el-input-number>
                            <span class="delay-tips">（选填，默认 0 表示立即打印，单位：秒）</span>
                        </el-form-item>
                        <el-form-item label="打印内容：" prop="content" required>
                            <el-input type="textarea" maxlength="2500" show-word-limit :rows="12" v-model="form.content"
                                placeholder="请输入打印内容，可根据右侧标签进行组合"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :loading="isLoading" @click="handleTest">立即提交</el-button>
                            <el-button type="warning" @click="reset">重新填写</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="right-container">
            <div class="div-title">
                <div class="iconfont icon-biaoqian"></div>
                <div class="div-label">打印标签</div>
            </div>
            <div class="tags-container">
                <div class="tags" v-for="(item, index) in $printTags" :key="index">
                    <div class="tag-label">{{ item.label }}</div>
                    <div class="tag-tips">{{ item.tips }}</div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            isLoading: false,
            headers: null,
            form: {
                imei: null,
                orderNo: null,
                content: null,
                delay: null
            },
            rule: {
                imei: [{ required: true, message: '请输入设备编号(SN)', trigger: 'blur' }],
                content: [{ required: true, message: '请输入打印内容', trigger: 'blur' },
                { min: 1, max: 2500, message: '密码长度在 1 到 2500 个字符', trigger: 'blur' }]
            }
        }
    },
    created() {
        let loginInfoStr = sessionStorage.getItem("loginInfo");
        this.loginInfo = JSON.parse(loginInfoStr);
        let developer = this.loginInfo.developer;
        let token = this.loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
    },
    methods: {
        handleTest() {
            this.$refs["printTestForm"].validate((valid) => {
                if (valid) {
                    this.isLoading = true;
                    let params = {
                        imei: this.form.imei,
                        orderNo: this.form.orderNo,
                        delay: this.form.delay,
                        content: this.form.content
                    }
                    this.axios.post(this.$apiUrl + "/developbackend/printTest", params, {
                        headers: this.headers
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.$showSuccessMsg("亲，打印任务已成功下发啦~");
                        } else {
                            this.$showErrorMsg(res.data.msg);
                        }
                        this.isLoading = false;
                    }).catch((e) => {
                        this.$showErrorMsg(e.toString());
                        this.isLoading = false;
                    });
                }
            });
        },
        reset() {
            this.form = {
                imei: null,
                orderNo: null,
                content: null,
                delay: null
            };
            this.$refs.printTestForm.resetFields();
        }
    }
}
</script>


<style scoped>
.test-container {
    height: 100%;
    padding-top: 5px;
    margin-right: 10px;
    display: flex;
}

.left-container {
    flex: 3;
    border: 1px solid #C0C6CC;
    margin-right: 15px;
    display: flex;
    flex-direction: column;
}

.form-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
}

.top-tips {
    margin: 15px;
    padding: 15px;
    background-color: #fff8eb;
    border: solid 1px #ffd6b1;
    border-left: 5px solid #ff7800;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.top-tips-label {
    color: #ff7800;
    font-weight: bold;
}

.form-main {
    flex: 1;
    padding: 0px 5px 0px 15px;
    height: 100%;
    overflow-y: scroll;
}

.delay-tips {
    color: red;
    font-weight: bold;
}

.right-container {
    flex: 2;
    border: 1px solid #C0C6CC;
    display: flex;
    flex-direction: column;
}

.tags-container {
    padding: 15px;
    height: 100%;
    overflow-y: scroll;
}

.tags+.tags {
    margin-top: 15px;
}

.tag-label {
    color: #c7254e;
    font-weight: bold;
}

.tag-tips {
    color: #909399;
}
</style>


// WEBPACK FOOTER //
// printTest.vue?ff980326